export default {
  ev_charging_station_daily_settlement: {
    name: '充电站日结算',
    prop: {
      settled_begin_time: '结算日',
      settled_date_range: '结算时间范围',
      settled_date: '结算日',
      ev_charging_station: '充电站',
      service_provider: '运营商',
      charge_channel: '渠道',
      net_income_amount: '运营商净收入',
      settled_amount: '结算原价',
      orders_consumed_power: '结算电量',
      settled_discount_amount: '优惠/商家让利',
      transaction_fee_amount: '交易手续费',
      total_tax_amount: '税费',
      total_sharing_amount: '渠道费',
      untransferred_amount: '未转账金额',
      is_merge_charge_channel: '合并渠道显示'
    },
    titles: {
      settlement_detail: '{0}结算明细'
    },
    labels: {
      count: '数量',
      order_charge_amount: '订单电费',
      service_amount: '服务费',
      discount_service_amount: '优惠后服务费'
    },
    placeholder: {
      select_is_merge_charge_channel: '请选择是否合并渠道显示'
    },
    is_merge_charge_channel_options: {
      true: '合并渠道展示',
      false: '独立渠道展示'
    }
  }
}
